
<ng-container *ngIf="progress > 0">
  <div class="uploader_progress">
  <mat-progress-spinner
  [color]="color"
  [mode]="mode"
  [value]="progress">
  </mat-progress-spinner>
</div>
</ng-container>

